<template>
  <div class="container">
    <v-layout
      wrap
      align-center
      justify-center
      row
      fill-height
    >
      <v-flex xs12>
        <h1>My Application</h1>
      </v-flex>
      <application-client-settings />
    </v-layout>
  </div>
</template>

<script>
// COMPONENTS
import ApplicationClientSettings from '@/components/applicationClient';

export default {
  name: 'MyApplication',
  components: {
    'application-client-settings': ApplicationClientSettings,
  },
};
</script>

<style lang="scss" >
</style>



// WEBPACK FOOTER //
// src/views/applicationClient/myApplication.vue